import { useState } from "react";
import { FilterBuilderV2 } from "../../../../../components/filter/FilterBuilderV2";
import { FilterRecord } from "../../../../../components/filter/filter-constant";
import useActiveComponentCountController from "../../../../../components/filter/use-ActiveComponentCountController";
import { useProviderListV2 } from "../../../../../queries/use-provider-list-v2";
import { useLocationOptionsV2 } from "../../../../../queries/use-location-options-v2";
import { useDebounce } from "../../../../../hooks/use-debounce";
import { DEF_PAGINATION, getXtenantId } from "../../../../../utils/utils";
import {
  PatientEncounterFilterData,
  ENCOUNTER_STATUS_OPTIONS,
  ENCOUNTER_MODE_OPTIONS,
  ENCOUNTER_TIME_INTERVAL_OPTIONS,
} from "./patient-encounter-constants";

interface PatientEncounterFiltersProps {
  filters: PatientEncounterFilterData;
  onApply: (v: PatientEncounterFilterData) => void;
}

const PatientEncounterFilters = ({
  filters,
  onApply,
}: PatientEncounterFiltersProps) => {
  const [filterOpened, setFilterOpened] = useState(false);
  const [searchProviderKey, setSearchProviderKey] = useDebounce<string>("");
  const [searchLocationKey, setSearchLocationKey] = useDebounce<string>("");
  const xTenantId = getXtenantId();

  const { data: providersList } = useProviderListV2({
    pagination: DEF_PAGINATION,
    searchString: searchProviderKey,
    xTENANTID: xTenantId,
    status: true,
    enabled: filterOpened,
  });

  const { data: locationsList } = useLocationOptionsV2({
    searchString: searchLocationKey,
    xTENANTID: xTenantId,
    enabled: filterOpened,
  });

  const filterConfig: FilterRecord = {
    date_range: {
      type: "date_range_preset",
      label: "Time Interval",
      childKeys: ["date_range", "startDate", "endDate"],
      options: ENCOUNTER_TIME_INTERVAL_OPTIONS,
    },
    provider_Name: {
      type: "select",
      label: "Provider",
      placeholder: "All Provider",
      options:
        providersList?.data?.content?.map((p: any) => ({
          value: p?.uuid,
          label: p?.name,
        })) ?? [],
      onSearch: (val: string) => setSearchProviderKey(val),
    },
    location: {
      type: "select",
      label: "Location",
      placeholder: "All Locations",
      options:
        locationsList?.data?.map((l: any) => ({
          value: l?.uuid,
          label: l?.name ?? l?.locationName,
        })) ?? [],
      onSearch: (val: string) => setSearchLocationKey(val),
    },
    appointment_Mode: {
      type: "select",
      label: "Mode",
      placeholder: "All Mode",
      options: ENCOUNTER_MODE_OPTIONS,
    },
    appointment_Status: {
      type: "select",
      label: "Status",
      placeholder: "All Statuses",
      options: ENCOUNTER_STATUS_OPTIONS,
    },
    search_Diagnosis: {
      type: "text",
      label: "Diagnosis",
      placeholder: "Search diagnosis...",
    },
    search_Patient: {
      type: "text",
      label: "Patient",
      placeholder: "Search patient...",
    },
  };

  const activeFilterCount = useActiveComponentCountController(
    filters as unknown as Record<string, unknown>
  );

  return (
    <div onClick={() => !filterOpened && setFilterOpened(true)}>
      <FilterBuilderV2
        filters={filterConfig}
        onApply={onApply}
        prefillValues={filters}
        activeFilterCount={activeFilterCount}
      />
    </div>
  );
};

export default PatientEncounterFilters;
